import strings from 'strings';
import { FormFieldsMap, FormFieldsMapForHA } from 'UI/components/organisms/CandidateForm/fields';

export const PAGE_KEY = 'new-candidate-drafts';

export const SOURCES = {
  FROM_DIRECTORY: 'fromDirectory',
  FROM_RESUME: 'fromResume',
  FROM_SCRATCH: 'fromScratch',
  FROM_TALENT_POOL: 'fromTalentPool',
  FROM_DRAFT: 'fromDraft'
};
export const SOURCE_LABELS = {
  [SOURCES.FROM_DIRECTORY]: strings.candidates.creation.source.directory,
  [SOURCES.FROM_RESUME]: strings.candidates.creation.source.resumeParser,
  [SOURCES.FROM_SCRATCH]: strings.candidates.creation.source.scratch,
  [SOURCES.FROM_TALENT_POOL]: strings.candidates.creation.source.talentPool,
  [SOURCES.FROM_DRAFT]: strings.candidates.creation.source.draft
};

export const FROM_SOURCE_KEY = 'fromSource';
export const FORM_FIELDS_MAP = FormFieldsMap;
export const FORM_FIELDS_MAP_FOR_HA = FormFieldsMapForHA;

export const DRAFT_REQUIRED_FIELDS = [
  FORM_FIELDS_MAP.FirstName.key,
  FORM_FIELDS_MAP.LastName.key,
  FORM_FIELDS_MAP.Email.key
];
